const channel = new BroadcastChannel('bdn-planning')

export function send(type, payload) {
  channel.postMessage({ type, payload })
}

export function listen(callback) {
  channel.onmessage = (event) => {
    callback(event.data)
  }
}
